import styled, { css } from 'styled-components'
import { colors } from '../../styles/constants'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  padding: ${props => (props.padding || '1rem')};
  background-color: ${colors.white};
  ${props => props.hasBorder && (`border: 1px solid ${colors.gray.default};`)}
  border-radius: 0.75rem;
  flex: 1;
  gap: 1rem;
  position: relative;
  height: 100%;

  ${({ full }) => full && FullCardStyles}
`

export const CardWrapper = styled.div`
  margin: ${props => (props.margin || '0')};

  width: ${({ full }) => full ? '100%' : 'fit-content'};
`

const FullCardStyles = css`
  flex: 1 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

export const CardSkeleton = styled.div`
  flex: 1;
  padding: '0px';
  ${props => props.full && (`
    flex: 1 1 100%;
  `)}
`
